import Card from "PFComponents/card/card";
import { Icon } from "PFComponents/icon";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { UpcomingBooking } from "PFTypes";
import React from "react";
import { humanize, titleize } from "underscore.string";

import css from "./upcoming_role_card.module.scss";

type RoleCardProps = {
  booking: UpcomingBooking;
};

export const UpcomingRoleCard = ({ booking }: RoleCardProps) => {
  const { formatDate, utc } = useDateFormatter();

  return (
    <Card rootClassName={css.card} bodyClassName={css.contentContainer}>
      <div className={css.header}>
        <Typography variant="h5" noMargin>
          {booking.activityName}
        </Typography>
        <RoleStatusBadge>{titleize(humanize(booking.bookingState))}</RoleStatusBadge>
      </div>
      <div className={css.row}>
        <Icon name="calendar" />
        <Typography variant="bodyRegular" noMargin>
          {`${formatDate(utc(booking.startDate))} - ${formatDate(utc(booking.endDate))}`}
        </Typography>
      </div>
    </Card>
  );
};
